import React from 'react'
import { logger } from 'lib/logger'
import dynamic from 'next/dynamic'

import B2BSteps from 'components/B2BSteps/B2BSteps'
import BusinessPageBottomCta from 'components/BusinessPageBottomCta/BusinessPageBottomCta'
import BusinessPageHelp from 'components/BusinessPageHelp/BusinessPageHelp'
import BusinessPageHero from 'components/BusinessPageHero/BusinessPageHero'
import BusinessPageIdeas from 'components/BusinessPageIdeas/BusinessPageIdeas'
import BusinessPageStats from 'components/BusinessPageStats/BusinessPageStats'
import BusinessPageTitle from 'components/BusinessPageTitle/BusinessPageTitle'
import BusinessReviewCardCollection from 'components/BusinessReviewCardCollection/BusinessReviewCardCollection'
import BusinessSuggestions from 'components/BusinessSuggestions/BusinessSuggestions'
import CustomerReviews from 'components/CustomerReviews/CustomerReviews'
import Faq from 'components/Faq/Faq'
import LandingBoxSection from 'components/LandingBoxSection/LandingBoxSection'
import LandingTextSection from 'components/LandingTextSection/LandingTextSection'

// eslint-disable-next-line import/no-cycle
import CmsItemBasic from './CmsItemBasic'

const BlogPost = dynamic(() => import('components/BlogPost/BlogPost'))

const staticComponents = {
  BusinessPageTitle,
  BusinessPageStats,
  BusinessPageIdeas,
  BusinessPageHelp,
  BusinessPageBottomCta,
}

export default function CmsItem({ item, wrapItems, indexPositionFromTop }) {
  switch (item.type) {
    case 'LandingBoxSection':
      return (
        <LandingBoxSection
          title={item.content.title}
          video={item.video?.url}
          boxes={item.boxes}
        />
      )
    case 'LandingTextSection':
      return (
        <LandingTextSection
          description={item.content.description}
          ctaButton={item.content.ctaButton}
          profileCollection={item.profileCollection}
        />
      )
    case 'CustomerReviews':
      return (
        <CustomerReviews
          title={item.content.title}
          reviews={item.content.reviews}
        />
      )
    case 'BlogPost':
      return (
        <BlogPost
          id={item.id}
          title={item.content.title}
          slug={item.slug}
          image={item.image?.url}
          content={item.content.content}
          excerpt={item.excerpt}
          categorySlug={item.category?.slug}
        />
      )
    case 'BusinessPageHero':
      return <BusinessPageHero profiles={item.profiles} />

    case 'BusinessSteps':
      return <B2BSteps profilesList={item.profilesList} color="#2C44A5" />

    case 'Static': {
      const Component = staticComponents[item.component]
      if (!Component) {
        logger.warn(`Component not found for static CMS item ${item.component}`)
        return null
      }

      return <Component />
    }

    case 'BusinessReviewCardCollection':
      return (
        <BusinessReviewCardCollection
          businessReviewCardList={item.businessReviewCardList}
        />
      )

    case 'BusinessSuggestions':
      return <BusinessSuggestions suggestions={item.suggestions} />

    case 'Faq':
      return <Faq faqList={item.faqList} />

    default:
      return (
        <CmsItemBasic
          item={item}
          wrapItems={wrapItems}
          indexPositionFromTop={indexPositionFromTop}
        />
      )
  }
}
